import React, { FC } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  TableCell,
  TableBody,
  Typography,
} from '@mui/material';
import { Modal } from '../../../dialogs/useModal';
import { useGuideCmsContext } from '../GuideCmsContext';
import { RichText } from '../../../components/richText';

export interface CitationLinkDialogResult {
  citationId: string;
}

export interface CitationLinkDialogProps {
  selectedText?: string;
}

export const CitationLinkDialog: FC<Modal<CitationLinkDialogProps, CitationLinkDialogResult>> = (modal) => {
  const { close } = modal;
  const { editor, guide } = useGuideCmsContext();
  const citations = guide?.citations ?? [];

  const handleOnClose = () => {
    close();
  };

  const addCitationLink = (payload: CitationLinkDialogResult) => {
    editor
      ?.chain()
      .focus()
      .insertContent({
        type: 'citationLink',
        attrs: { citationId: payload.citationId },
      })
      .run();
  };

  return (
    <Dialog open={true} onClose={handleOnClose} disableRestoreFocus maxWidth="md" fullWidth>
      <DialogTitle>Legg til litteraturhenvisning</DialogTitle>
      <DialogContent>
        {citations.length === 0 ? (
          <Typography color="textSecondary">
            Ingen litteraturhenvisninger registrert på denne anvisningen. Legg dem til under Innholdspublisering først.
          </Typography>
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Velg</TableCell>
                  <TableCell>Tekst</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {citations.map((citation) => {
                  if (!citation) return null;
                  return (
                    <TableRow key={citation.id}>
                      <TableCell>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => {
                            const result: CitationLinkDialogResult = { citationId: citation.id };
                            addCitationLink(result);
                            close(result);
                          }}>
                          Velg
                        </Button>
                      </TableCell>
                      <TableCell sx={{ whiteSpace: 'pre-wrap' }}>
                        <RichText html={citation.text} />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOnClose}>Avbryt</Button>
      </DialogActions>
    </Dialog>
  );
};
